var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"card-info-lead"}},[_c('div',{staticClass:"card border-radius-3"},[_c('div',{class:'card-content center '+_vm.setCurrent()},[_c('i',{staticClass:"material-icons medium white-text"},[_vm._v(_vm._s(_vm.icone))]),_vm._v(" "),_c('p',{staticClass:"white-text lighten-4"},[_vm._v(_vm._s(_vm.titulo))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9d48fe2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lead/CardInfo.vue
// module id = null
// module chunks = 